import Container from "@components/ui/container.tsx";
import BackButton from "@components/back_button.tsx";
import {
  SubscriptionForm,
  type SubscriptionFormData,
} from "@components/job_alerts/subscription_form.tsx";

const Subscription = (props: SubscriptionFormData) => {
  const returnPath = props.hasSubscriptions ? props.subscriptionsPath : props.dashboardPath;

  return (
    <Container>
      <BackButton href={returnPath} />
      <SubscriptionForm {...props} />
    </Container>
  );
};

export default Subscription;
